import { render } from "./BannerPages.vue?vue&type=template&id=56431e9c"
import script from "./BannerPages.vue?vue&type=script&lang=js"
export * from "./BannerPages.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__